import { createContext, useContext, useEffect, useState } from "react";
import { DEFAULTS } from "@/content";

const API = process.env.REACT_APP_BACKEND_URL;

const SiteContentContext = createContext({ overrides: {} });

export const SiteContentProvider = ({ children }) => {
  const [overrides, setOverrides] = useState({});

  useEffect(() => {
    const load = () =>
      fetch(`${API}/api/content`)
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error())))
        .then((d) => setOverrides(d || {}))
        .catch(() => {});
    load();
    window.addEventListener("nox-content-changed", load);
    return () => window.removeEventListener("nox-content-changed", load);
  }, []);

  return <SiteContentContext.Provider value={{ overrides }}>{children}</SiteContentContext.Provider>;
};

export const useSiteContent = () => useContext(SiteContentContext);

// t("intro.hero.eyebrow") → vault override or the shipped default.
export const useT = () => {
  const { overrides } = useSiteContent();
  return (key) => overrides[key] ?? DEFAULTS[key] ?? "";
};

// Renders plain text with *words* as gold accents (the inline "formatting" accent).
export const Rich = ({ text, as: Tag = "span", className = "" }) => {
  if (!text) return null;
  const parts = String(text).split(/\*([^*]+)\*/g);
  return (
    <Tag className={className}>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className="text-gold">
            {part}
          </span>
        ) : (
          part
        )
      )}
    </Tag>
  );
};
